import { ConfirmButtonGroup, twClassMerge  } from '@healthhub/react-ui';
import type { ModalProps } from 'antd';
import { Modal, Typography } from 'antd';
import type { ReactElement, ReactNode } from 'react';



interface IConfirmModalProps extends ModalProps {
  cancelDisabled?: boolean;
  cancelLoading?: boolean;
  cancelText?: string;
  children?: ReactElement;
  className?: string;
  descriptionBottom?: string;
  descriptionTop?: ReactNode;
  disabled?: boolean;
  extraButtons?: ReactElement;
  loading?: boolean;
  okText?: string;
  onCancel?: () => void;
  onOk?: () => void;
  title?: ReactNode;
}

const { Text, Title } = Typography;

const ConfirmModal = ({
  cancelDisabled,
  cancelLoading,
  cancelText,
  children,
  className,
  descriptionBottom,
  descriptionTop,
  disabled,
  extraButtons,
  loading,
  okText,
  onCancel,
  onOk,
  title,
  ...rest
}: IConfirmModalProps) => (
  <Modal
    centered
    className={twClassMerge('[&_.ant-modal-body]:p-4 [&_.ant-modal-content]:rounded-lg', className)}
    closable={false}
    destroyOnHidden
    footer={null}
    {...rest}
  >
    {!!(title || descriptionTop || descriptionBottom) && (
      <div className="mb-6 mt-2 flex flex-col gap-2">
        {!!title && <Title className="mb-0 text-center text-base font-bold">{title}</Title>}
        {!!descriptionTop && <Text className="block text-center text-sm">{descriptionTop}</Text>}
        {!!descriptionBottom && <Text className="block text-center text-sm">{descriptionBottom}</Text>}
      </div>
    )}
    {children}

    <ConfirmButtonGroup
      cancelDisabled={cancelDisabled}
      cancelLoading={cancelLoading}
      cancelText={cancelText}
      extraButtons={extraButtons}
      handleCancel={onCancel}
      handleSubmit={onOk}
      isLoading={loading}
      okDisabled={loading ?? disabled}
      okText={okText}
    />
  </Modal>
);

export default ConfirmModal;
